import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import RightArrow from "../../components/SVG";
import BlogNews from "../../components/Blog/BlogNews";

const formatDate = (dateString) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(dateString).toLocaleDateString("en-US", options);
};

// Helper to strip HTML tags
const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const Blog = ({ news = [] }) => {
  if (!news.length) return null;

  return (
    <div className="it-blog-area pt-50">
      <div className="container">
        <div className="it-blog-title-wrap mb-60">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <SectionTitle
                itemClass="it-blog-title-box"
                subTitle="Current News"
                title="Current Updates from SAP Office."
              />
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <div className="it-blog-button text-start text-md-end">
                <Link className="ed-btn-theme" to="/news">
                  View All News
                  <i>
                    <RightArrow />
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {news.map((item, index) => (
            <div
              key={item._id}
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={`.${3 + index * 2}s`}
            >
              <BlogNews
                blogImage={item.imageUrl?.[0] || ""}
                heading={item.title}
                title={stripHtml(item.description).slice(0, 300) + "..."}
                publishedDate={formatDate(item.date)}
                btnClass="ed-btn-blog"
                hasArrow
                _id={item._id}
                type="news"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
